import React, { useEffect, useState } from "react";
import { AiOutlinePlayCircle } from "react-icons/ai";
import { audioOptions } from "../../helpers/constantVariables";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { useStores } from "../../store";
import { useObserver } from "mobx-react";
import { IoPauseCircleOutline } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";

const InterviewSetting2 = () => {
  const { RecuiterStore, InterviewStore } = useStores();
  const [speaking, setSpeaking] = useState(false);

  const mapVolumeToDecibels = (percentage) => {
    const minDb = -100; // Minimum decibel level
    const maxDb = 0; // Maximum decibel level
    return `${(percentage / 100) * (maxDb - minDb) + minDb}dB`;
  };
  const [showModal, setShowModal] = useState(false);

  const speak = ({
    text,
    voice = "en-US-AriaNeural",
    vol = "1.0",
    region = process.env.REACT_APP_SPEECH_REGION ?? "centralindia",
  }) => {
    console.log("this is the region", process.env.REACT_APP_SPEECH_REGION);
    try {
      const enableBackupAzureSpeechKey =
        process.env.REACT_APP_ENABLE_BACKUP_AZURE_SPEECH_KEY;

      const speechKey =
        enableBackupAzureSpeechKey === "true"
          ? process.env.REACT_APP_BACKUP_AZURE_SPEECH_KEY
          : process.env.REACT_APP_AZURE_SPEECH_KEY;
      if (!speechKey) {
        console.error("Azure Speech Key is missing");
        return;
      }
      const volumeDecibels = mapVolumeToDecibels(vol);
      const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
        speechKey,
        region
      );
      const synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig);

      const ssmlText = `
    <speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">
      <voice name="${voice}">
        <prosody volume="${vol}%">
          ${text}
        </prosody>
      </voice>
    </speak>
  `;

      synthesizer.speakSsmlAsync(
        ssmlText,
        (result) => {
          if (
            result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted
          ) {
            console.log(`Speech synthesized successfully for text: "${text}"`);
          } else if (result.reason === SpeechSDK.ResultReason.Canceled) {
            console.error("Speech synthesis canceled:", result.errorDetails);
          }
          synthesizer.close();
        },
        (err) => {
          console.error("Error during speech synthesis:", err);
          synthesizer.close();
        }
      );
    } catch (error) {}
  };

  const aivoice = RecuiterStore.jobPostDetails.customSettings.find(
    (setting) => setting.name === "aiVoice"
  )?.value;
  useEffect(() => {
    setSelectedOption(aivoice ?? 3);
  }, [aivoice]);

  const [selectedOption, setSelectedOption] = useState(3);
  const [selectedVoice, setSelectedVoice] = useState(
    audioOptions.find((option) => option.id === aivoice)
  );

  const [volume, setVolume] = useState(50);

  return useObserver(() => (
    <div>
      <h2 className="text-2xl font-bold text-orange-500 mb-4 flex items-center px-1 pb-3 md:pt-6">
        Audio & Avatar Settings
      </h2>
      <div className="w-full max-w-lg mx-auto bg-white border border-primary rounded-lg ">
        <table className="w-full border-collapse mt-2 border-none">
          <tbody className="">
            {audioOptions.map((option) => (
              <tr
                key={option.id}
                className="hover: cursor-pointer"
                onClick={() => {
                  setSelectedOption(option.id);
                  setSelectedVoice(option);
                  RecuiterStore.setJobPostCustomSettings("aiVoice", option.id);
                  InterviewStore.setSelectedAudio(option);
                }}
              >
                <td className="px-5 py-2">
                  <div className="flex items-center space-x-4">
                    <img
                      src={option.image}
                      alt={option.label}
                      className="w-7 h-7 rounded-full object-cover"
                    />
                    <span className="text-gray-800 font-medium">
                      {option.label}
                      {","} {option.country}{" "}
                      <span className="opacity-80">({option.gender})</span>
                    </span>
                  </div>
                </td>
                <td className="p-2 relative">
                  <input
                    type="radio"
                    name="audioAvatar"
                    required
                    className="peer h-4 w-4 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-primary"
                    checked={Number(selectedOption) === Number(option.id)}
                    readOnly
                  />
                  <span className="absolute bg-primary w-2 h-2 rounded-full opacity-0 peer-checked:opacity-100 top-[1.2em] left-4 transform -translate-x-1/2 -translate-y-1/2"></span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <table className="w-full border-t-2 border-primary mt-2">
          <tbody>
            <tr>
              <td className="p-3 cursor-pointer">
                <div className="flex items-center space-x-4">
                  {selectedVoice && (
                    <img
                      src={selectedVoice.image}
                      alt={selectedVoice.label}
                      className="w-10 h-10 rounded-full object-cover"
                      onClick={() => setShowModal(true)}
                    />
                  )}
                  <span className="text-gray-800 font-medium">
                    {selectedVoice?.label && `${selectedVoice?.label}, `}
                    {selectedVoice?.country}{" "}
                    {selectedVoice?.gender.length > 0 && (
                      <span className="opacity-80">
                        ({selectedVoice?.gender})
                      </span>
                    )}
                  </span>
                </div>
                {showModal && selectedVoice && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm z-50">
                    <div className="relative bg-white p-8 rounded-xl shadow-2xl max-w-md w-full mx-4 transform transition-all">
                      <button
                        onClick={() => setShowModal(false)}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                      >
                        <IoIosCloseCircleOutline size={24} />
                      </button>

                      <div className="flex flex-col items-center space-y-4">
                        <img
                          src={selectedVoice.image}
                          alt={selectedVoice.label}
                          className="w-24 h-24 rounded-full object-cover ring-4 ring-primary/10"
                        />
                        <div className="text-center space-y-2">
                          <h3 className="text-xl font-semibold text-gray-800">
                            {selectedVoice.label}
                          </h3>
                          <p className="text-gray-600">
                            {selectedVoice.gender} • {selectedVoice.country}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </td>
              <td className="py-3">
                <span className="w-full flex justify-end pr-2">
                  {speaking ? (
                    <IoPauseCircleOutline
                      size={34}
                      className="text-primary cursor-not-allowed"
                    />
                  ) : (
                    <AiOutlinePlayCircle
                      size={34}
                      className={`text-primary ${
                        selectedVoice ? "cursor-pointer" : "cursor-not-allowed"
                      }`}
                      onClick={() => {
                        if (!selectedVoice) return;
                        setSpeaking(true);
                        speak({
                          text: `Hello, I am ${selectedVoice?.label}. I am your Interviewer. How can I help you?`,
                          voice: selectedVoice?.voice,
                          vol: 100,
                        });
                        setTimeout(() => {
                          setSpeaking(false);
                        }, 8000);
                      }}
                    />
                  )}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  ));
};

export default InterviewSetting2;
